<template>
  <div name="hres6oe-history-in-out" class="checkin-google-map">
    <div v-if="data[0].month !== '0'">
      <template v-for="(monthRows, monthIndex) in data">
        <div :key="monthIndex" class="hisCalendar">
          <i class="fa fa-calendar" aria-hidden="true"></i> {{ month[nowLang][parseInt(monthRows.month)-1]['full'] }} {{ monthRows.year }}
        </div>
        <div :key="monthIndex" class="calendar-history-box">
          <div :key="dayIndex"
                v-for="(dayRows, dayIndex) in monthRows.days"
                class="history-set">
            <div class="panel-left">
              <div class="date">{{dayRows.day}}</div>
              <div class="day">{{dayRows.dayweek}}</div>
            </div>
            <div :key="dataIndex"
                  v-for="(dataRow, dataIndex) in dayRows.details"
                  @click="callHistoryDetail(dataRow)" >
              <div class="panel-right">
                <div class="workplace">{{dataRow.namcust}}</div>
                <div class="codejob">{{dataRow.namreason}}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div v-else class="no-history">
      No Histories.
    </div>
    <div class="panel-button">
      <div class="button-md _bg-grey" :class="pcDisp ? '' : '-mobile'" @click="back()">Back</div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'hres6oe-history-in-out',
  props: [
    'data',
    'label',
    'toggle',
    'setHistorySelected',
    'nowLang',
    'pcDisp',
    'scrollTop'
  ],
  data () {
    return {
      dateTmp: '',
      selected: '',
      month: {
        en: [{
          full: 'January',
          short: 'Jan'
        }, {
          full: 'February',
          short: 'Feb'
        }, {
          full: 'March',
          short: 'Mar'
        }, {
          full: 'April',
          short: 'Apr'
        }, {
          full: 'May',
          short: 'May'
        }, {
          full: 'June',
          short: 'Jun'
        }, {
          full: 'July',
          short: 'Jul'
        }, {
          full: 'August',
          short: 'Aug'
        }, {
          full: 'September',
          short: 'Sep'
        }, {
          full: 'October',
          short: 'Oct'
        }, {
          full: 'November',
          short: 'Nov'
        }, {
          full: 'December',
          short: 'Dec'
        }],
        th: [{
          full: 'มกราคม',
          short: 'ม.ค.'
        }, {
          full: 'กุมภาพันธ์',
          short: 'ก.พ.'
        }, {
          full: 'มีนาคม',
          short: 'มี.ค.'
        }, {
          full: 'เมษายน',
          short: 'เม.ย.'
        }, {
          full: 'พฤษภาคม',
          short: 'พ.ค.'
        }, {
          full: 'มิถุนายน',
          short: 'มิ.ย.'
        }, {
          full: 'กรกฏาคม',
          short: 'ก.ค.'
        }, {
          full: 'สิงหาคม',
          short: 'ส.ค.'
        }, {
          full: 'กันยายน',
          short: 'ก.ย.'
        }, {
          full: 'ตุลาคม',
          short: 'ต.ค.'
        }, {
          full: 'พฤศจิกายน',
          short: 'พ.ย.'
        }, {
          full: 'ธันวาคม',
          short: 'ธ.ค.'
        }]
      }
    }
  },
  methods: {
    callHistoryDetail (dataRow) {
      this.setHistorySelected(dataRow)
      this.toggle('hisDetail')
    },
    back () {
      this.toggle('place')
      this.scrollTop()
    }
  }
}
</script>



// WEBPACK FOOTER //
// historyInOut.vue?8944652a